import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import ButtonText from 'components/shared/ButtonText';
import Text from 'components/shared/Text';

function UnverifiedText({ idVerified, idVerificationInProgress, totpEnabled }) {
  const microapps = window.MICROFRONTENDS_CONFIG;
  return (
    <Text tall centered>
      {!idVerified && !idVerificationInProgress && !totpEnabled && (
        <Trans i18nKey="header_verif_new_2fa">
          <ButtonText to={microapps?.routes.verification.path} />
          <ButtonText to={microapps?.routes.accountSecurity.path} />
        </Trans>
      )}
      {!idVerified && !idVerificationInProgress && totpEnabled && (
        <Trans i18nKey="header_verif_new">
          <ButtonText to={microapps?.routes.verification.path} />
        </Trans>
      )}
      {!idVerified && idVerificationInProgress && !totpEnabled && (
        <Trans i18nKey="header_verif_pending_2fa">
          <ButtonText to={microapps?.routes.accountGeneral.path} />
          <ButtonText to={microapps?.routes.accountSecurity.path} />
        </Trans>
      )}
      {!idVerified && idVerificationInProgress && totpEnabled && (
        <Trans i18nKey="header_verif_pending">
          <ButtonText to={microapps?.routes.accountGeneral.path} />
        </Trans>
      )}
      {idVerified && !totpEnabled && (
        <Trans i18nKey="header_verif_confirmed_2fa">
          <ButtonText to={microapps?.routes.accountSecurity.path} />
        </Trans>
      )}
    </Text>
  );
}

UnverifiedText.propTypes = {
  idVerified: PropTypes.bool.isRequired,
  idVerificationInProgress: PropTypes.bool.isRequired,
  totpEnabled: PropTypes.bool.isRequired
};

export default UnverifiedText;
